module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNy44NjQiIGhlaWdodD0iMjYuNSIgdmlld0JveD0iMCAwIDI3Ljg2NCAyNi41Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYzEwZTIxO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTMwLjQzNSwxMi44MDVsLTkuNjI3LTEuNEwxNi41LDIuNjgzLDEyLjIsMTEuNDA2bC05LjYyNywxLjRMOS41MzcsMTkuNiw3Ljg5MiwyOS4xODNsOC42MS00LjUyNyw4LjYxLDQuNTI3TDIzLjQ2OSwxOS42bDYuOTY2LTYuNzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi41NzEgLTIuNjgzKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/icons/aha-heart.svg
// module id = 148
// module chunks = 0 1